module.exports = __webpack_public_path__ + "static/media/Crazy Scientist (Series 4).f2e3fd37.jpg";